var map = {
	"./dentata.svg": 731,
	"./elm.svg": 226,
	"./email.svg": 168,
	"./external.svg": 974,
	"./github.svg": 405,
	"./javascript.svg": 254,
	"./linkedin.svg": 328,
	"./noise.svg": 85,
	"./python.svg": 730,
	"./ruby.svg": 903,
	"./rust.svg": 194,
	"./squiggle.svg": 476,
	"./swift.svg": 323,
	"./system.svg": 54,
	"./typescript.svg": 30
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 968;